<template>
  <div>
    <div
      style="position: fixed; top: 20px; z-index: 6; backdrop-filter: blur(2px)"
      v-if="LoaderStatus"
    >
      <Spinner />
    </div>
    <div class="main-container" style="padding-bottom: 20px">
      <div class="dashboardAdmin-header position-relative">
        <div
          class="
            dashboardAdmin-header-main-head
            ml-2
            d-flex
            justify-content-between
            bluebtn
          "
        >
          <div class="align-self-lg-center d-flex gap-10 text-capitalize">
            <img
              v-if="$route.query.fromPage"
              @click="goToKanban()"
              src="@/assets/img/feedbackform/backarrow.svg"
              class="pointer"
              alt
            />
            {{ analysisData.candidateInfo.name }}'s Interview Analysis
          </div>
          <section class="d-flex align-items-center gap-15">
            <div class="position-relative">
              <div
                class="pointer"
                v-closable="{
                  handler: 'closeShareModal',
                  exclude: ['sharebtn', 'sharelink'],
                }"
              >
                <img
                  @click="sharedModal = !sharedModal"
                  v-b-tooltip.hover.bottom="'Share'"
                  src="@/assets/img/newcreatejob/share.svg"
                  alt
                />
              </div>
              <div ref="sharelink" class="ihd-sharemodal" v-if="sharedModal">
                <div
                  class="d-flex align-items-center justify-content-between mb-2"
                >
                  <div class="ihd-share-head">Copy link to Share</div>
                  <img
                    @click="sharedModal = false"
                    class="pointer"
                    src="@/assets/img/newcreatejob/x-close.svg"
                    alt
                  />
                </div>
                <div class="ihd-share-input d-flex align-items-center mb-1">
                  <!-- :style="!linkCopied ? 'width:92%' : 'width: 83%'" === bind this for below div -->
                  <div :style="!linkCopied ? 'width:92%' : 'width: 83%'">
                    <div class="w-100 text-truncate">
                      {{ getLink }}
                    </div>
                  </div>
                  <!--     :style="!linkCopied ? 'width:25%' : 'width: 17%'"  === bind this for below div -->
                  <div
                    ref="sharedLink"
                    :style="!linkCopied ? 'width:25%' : 'width: 17%'"
                    class="d-flex justify-content-end"
                  >
                    <img
                      v-if="!linkCopied"
                      @click="copyTheLink()"
                      class="pointer"
                      src="@/assets/img/newcreatejob/copy.svg"
                      alt
                    />
                    <div
                      class="
                        ihd-share-copied-txt
                        d-flex
                        align-items-center
                        ml-1
                      "
                      v-else-if="linkCopied"
                    >
                      <img
                        src="@/assets/img/newcreatejob/copied.svg"
                        class="mr-1"
                        alt
                      />
                      Copied
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <b-button
              v-if="analysisData.aiReport"
              @click="isDownloading ? '' : getDownloadData()"
              :disabled="isDownloading"
              class="acs-addBtn-modal"
            >
              <span>Download Report</span>
            </b-button>
            <div
              v-if="
                roles.includes('GET_PROFILE') &&
                analysisData.candidateInfo.isBuilderProfileAvailable
              "
              class="position-relative newprimarybtn pointer"
            >
              <b-button
                @click="goToProfilePage()"
                class="w-100 d-flex align-items-center justify-content-center"
              >
                <span>View Candidate Profile</span>
              </b-button>
            </div>
            <div
              v-if="analysisData.feedbackProvided"
              class="position-relative newprimarybtn pointer"
            >
              <b-button
                @click="getFeedBack()"
                class="w-100 d-flex align-items-center justify-content-center"
              >
                <span>View Panel Feedback</span>
              </b-button>
            </div>
          </section>
        </div>
      </div>
      <section
        class="d-flex gap-15 w-100 mt-3"
        style="height: calc(100vh - 160px)"
      >
        <section
          :style="
            analysisData.videoLink || analysisData.interviewImage
              ? 'width: 70%'
              : 'width: 100%'
          "
          class="h-100"
        >
          <div class="newJD-right-container relativeclass w-100">
            <div
              class="newInt-control-tabs relativeclass w-100 botanalysistab"
              :class="tabIndex == 1 && 'hide-scroll-container'"
            >
              <b-tabs
                v-model="tabIndex"
                v-if="!LoaderStatus"
                class="position-relative"
              >
                <img
                  src="@/assets/img/botanalysis/hire3xai.svg"
                  class="position-absolute"
                  style="top: 11px; right: 16px"
                  alt
                />
                <b-tab
                  v-if="analysisData.interviewSummary"
                  title="Notes"
                  class="pr-1"
                >
                  <div class="fs-18 fw-700 font-mont color-mainblue">
                    <img
                      src="@/assets/img/botanalysis/intsummary.svg"
                      class="mr-2"
                      alt
                    />
                    Interview Summary
                  </div>
                  <div
                    v-html="formattedSummary"
                    class="mt-3 markdown-output"
                  ></div>
                  <!-- <section class="mt-3">
                    <div>
                      <h3 class="fs-16 fw-600 font-mont color-282828">
                        Internship experience
                      </h3>
                      <p class="fw-400 fs-16 font-inter color-515151 my-2">
                        Yorem ipsum dolor sit amet, consectetur adipiscing elit.
                        Etiam eu turpis molestie, dictum est a, mattis tellus.
                        Sed dignissim, metus nec fringilla accumsan, risus sem
                        sollicitudin lacus, ut interdum t
                      </p>
                    </div>
                    <div>
                      <p
                        class="
                          font-inter
                          fw-500
                          fs-16
                          color-515151
                          text-underline
                        "
                      >
                        Categories found:-
                      </p>
                      <ul>
                        <li
                          class="text-left font-inter fw-500 fs-16 color-515151"
                        >
                          This is the summarized option 1
                        </li>
                        <li
                          class="text-left font-inter fw-500 fs-16 color-515151"
                        >
                          summarized option 2
                        </li>
                      </ul>
                    </div>
                  <hr class="divider" />-->

                  <!-- Second Block -->
                  <!-- <div>
                      <h3 class="fs-16 fw-600 font-mont color-282828">
                        A summarized heading for title
                      </h3>
                      <p class="fw-400 fs-16 font-inter color-515151 my-2">
                        Yorem ipsum dolor sit amet, consectetur adipiscing elit.
                        Etiam eu turpis molestie, dictum est a, mattis tellus.
                        Sed dignissim, metus nec fringilla accumsan, risus sem
                        sollicitudin lacus, ut interdum t
                      </p>
                      <p
                        class="
                          font-inter
                          fw-500
                          fs-16
                          color-515151
                          text-underline
                        "
                      >
                        Categories found:-
                      </p>
                      <ul>
                        <li
                          class="text-left font-inter fw-500 fs-16 color-515151"
                        >
                          This is the summarized option 1
                        </li>
                        <li
                          class="text-left font-inter fw-500 fs-16 color-515151"
                        >
                          summarized option 2
                        </li>
                        <li
                          class="text-left font-inter fw-500 fs-16 color-515151"
                        >
                          summarized option 2
                        </li>
                        <li
                          class="text-left font-inter fw-500 fs-16 color-515151"
                        >
                          summarized option 2
                        </li>
                      </ul>
                    </div>
                  </section>-->
                </b-tab>
                <b-tab
                  title="Transcripts"
                  class="pr-1"
                  v-if="analysisData.transcript"
                  @click="setTranscript()"
                >
                  <section>
                    <div class="font-mont fw-600 fs-14 color-656565 mb-2">
                      Keywords:-
                    </div>
                    <div class="d-flex flex-wrap align-items-center gap-10">
                      <!-- bind "bg-mainblue color-white" classes for below div for selected tag -->
                      <div
                        class="botanalysis-tags font-mont fw-500 fs-14 pointer"
                        :class="
                          checkKeyword(word)
                            ? 'bg-mainblue color-white'
                            : 'color-656565'
                        "
                        @click="pauseVideo('word', word)"
                        v-for="(word, index) in analysisData.keywords"
                        :key="index"
                      >
                        {{ capitalizeFirstLetter(word) }}
                      </div>
                    </div>
                  </section>

                  <section class="mt-3 tagssection-border pb-3">
                    <div class="font-mont fw-600 fs-14 color-656565 mb-2">
                      Speakers:-
                    </div>
                    <div class="d-flex flex-wrap align-items-center gap-10">
                      <!-- bind "bg-mainblue color-white" classes for below div for selected tag -->

                      <div
                        class="
                          botanalysis-tags
                          font-mont
                          fw-500
                          fs-14
                          d-inline-flex
                          align-items-center
                          pointer
                        "
                        :class="
                          checkHighlight(speaker.speakerName) ||
                          selectedTranscript.speaker == speaker.speakerName
                            ? 'bg-mainblue color-white'
                            : 'color-656565'
                        "
                        @click="pauseVideo('speaker', speaker.speakerName)"
                        v-for="(speaker, index) in reversedSpeakers"
                        :key="speaker.speakerName + index"
                      >
                        <div class="tagdp common-sm-profile-icon mr-1">
                          <b-avatar
                            :text="speaker.speakerName[0].toUpperCase()"
                            class="font-13px"
                            style="margin-top: -4px"
                          ></b-avatar>
                          <!-- <img
                            src="@/assets/img/botanalysis/david.png"
                            class="h-100 w-100 overflow-hidden"
                            alt=""
                          />-->
                        </div>
                        {{ speaker.speakerName }}
                        <div
                          class="
                            ml-1
                            botanalysis-subtags
                            color-828690
                            font-mont
                            fs-12
                            fw-500
                            d-flex
                            align-items-center
                          "
                        >
                          {{ speaker.conversationPercentage }}%
                        </div>
                      </div>
                    </div>
                  </section>
                  <section
                    class="ba-transcript-conatiner mt-3"
                    ref="transcriptContainer"
                  >
                    <div class="fs-16 fw-700 font-mont color-mainblue">
                      <img
                        src="@/assets/img/botanalysis/intsummary.svg"
                        class="mr-2"
                        alt
                      />
                      Transcript
                    </div>
                    <hr class="my-2" />
                    <!-- while writing loop make sure first index does take mt-3 rest mt-0 -->
                    <section
                      v-for="(item, index) in analysisData.transcript"
                      :key="index"
                      :ref="item.highlight ? 'highlightedSection' : null"
                      class="d-flex align-items-baseline pointer"
                      :class="index == 0 && 'mt-3'"
                      @click="vidplay(item.start)"
                    >
                      <div style="width: 5%">
                        <div class="transcript-dp common-sm-profile-icon">
                          <b-avatar
                            :text="item.speaker[0].toUpperCase()"
                          ></b-avatar>
                          <!-- <img
                              src="@/assets/img/botanalysis/david.png"
                              class="h-100 w-100 overflow-hidden"
                              alt=""
                          />-->
                        </div>
                      </div>
                      <div style="width: 95%">
                        <div
                          class="
                            d-flex
                            align-items-center
                            justify-content-between
                          "
                        >
                          <div
                            class="
                              fs-14
                              fw-600
                              font-mont
                              color-282828
                              d-inline-flex
                              align-items-center
                            "
                          >
                            {{ item.speaker }}
                            <div
                              class="
                                transcript-time-tag
                                fw-600
                                fs-12
                                font-lato
                                color-828690
                                ml-2
                              "
                            >
                              {{ formatSecondsToMinSec(item.start) }}
                            </div>
                          </div>
                          <div
                            v-if="item.speaker == candidate.name"
                            class="
                              transcripttag
                              fw-500
                              fs-12
                              font-mont
                              color-mainblue
                              candidatetag-bg
                            "
                          >
                            Candidate
                          </div>
                          <div
                            v-else
                            class="
                              transcripttag
                              fw-500
                              fs-12
                              font-mont
                              color-panelist
                              panelist-bg
                            "
                          >
                            Panelist
                          </div>
                        </div>
                        <div class="mt-3">
                          <p
                            class="fw-400 fs-16 font-inter my-2"
                            :class="
                              item.highlight ||
                              selectedTranscript.transcripts.includes(
                                item.start
                              )
                                ? 'color-mainblue selected-paragraph'
                                : 'color-515151'
                            "
                          >
                            {{ item.text }}
                          </p>
                        </div>
                        <div class="divider"></div>
                      </div>
                    </section>

                    <!-- <section>
                      <section class="d-flex align-items-baseline">
                        <div style="width: 5%">
                          <div class="transcript-dp">
                            <img
                              src="@/assets/img/botanalysis/david.png"
                              class="h-100 w-100 overflow-hidden"
                              alt=""
                            />
                          </div>
                        </div>
                        <div style="width: 95%">
                          <div
                            class="
                              d-flex
                              align-items-center
                              justify-content-between
                            "
                          >
                            <div
                              class="
                                fs-14
                                fw-600
                                font-mont
                                color-282828
                                d-inline-flex
                                align-items-center
                              "
                            >
                              Amanda Blake
                              <div
                                class="
                                  transcript-time-tag
                                  fw-600
                                  fs-12
                                  font-lato
                                  color-828690
                                  ml-2
                                "
                              >
                                01:00
                              </div>
                            </div>
                            <div
                              class="
                                transcripttag
                                fw-500
                                fs-12
                                font-mont
                                color-mainblue
                                candidatetag-bg
                              "
                            >
                              Candidate
                            </div>
                          </div>
                          <div class="mt-3">
                            <p
                              class="
                                fw-400
                                fs-16
                                font-inter
                                color-mainblue
                                my-2
                                selected-paragraph
                              "
                            >
                              Yorem ipsum dolor sit amet, consectetur adipiscing
                              elit. Etiam eu turpis molestie, dictum est a,
                              mattis tellus. Sed dignissim, metus nec fringilla
                              accumsan, risus sem sollicitudin lacus, ut
                              interdum t
                            </p>
                            <p
                              class="fw-400 fs-16 font-inter color-515151 my-2"
                            >
                              Yorem ipsum dolor sit amet, consectetur adipiscing
                              elit. Etiam eu turpis molestie, dictum est a,
                              mattis tellus. Sed dignissim, metus nec fringilla
                              accumsan, risus sem sollicitudin lacus, ut
                              interdum t
                            </p>
                          </div>
                        </div>
                      </section>
                    </section>-->
                  </section>
                </b-tab>
                <b-tab v-if="analysisData.metrics" title="Metrics" class="pr-1">
                  <section
                    v-if="
                      Object.keys(analysisData).length != 0 && !LoaderStatus
                    "
                    class="d-flex flex-column gap-15"
                  >
                    <!-- Face match -->
                    <section>
                      <div
                        class="
                          metrics-containers
                          d-flex
                          align-items-center
                          justify-content-between
                        "
                        v-if="
                          analysisData.comparisonScore ||
                          analysisData.comparisonScore == 0
                        "
                      >
                        <div class="d-flex align-items-center gap-10">
                          <img
                            :src="
                              require('@/assets/img/botanalysis/facematch.svg')
                            "
                            alt
                          />
                          <div class="fs-16 fw-700 font-mont color-mainblue">
                            Identity Match (%)
                          </div>
                        </div>
                        <div class="d-flex align-items-center gap-10">
                          <div
                            :class="
                              Math.round(analysisData.comparisonScore) < 50
                                ? 'color-red'
                                : Math.round(analysisData.comparisonScore) >= 70
                                ? 'color-green'
                                : 'color-orange'
                            "
                            :style="
                              Math.round(analysisData.comparisonScore) < 50
                                ? 'background: rgb(251, 235, 234);'
                                : Math.round(analysisData.comparisonScore) >= 70
                                ? ''
                                : 'background: #ffdd8073'
                            "
                            class="
                              metric-green-time
                              fs-14
                              font-mont
                              fw-800
                              w-140px
                              text-center
                            "
                          >
                            <span
                              >{{
                                Math.round(analysisData.comparisonScore)
                              }}%</span
                            >
                          </div>
                        </div>
                      </div>
                    </section>
                    <!-- 1. Duration Of Talk -->
                    <section>
                      <div
                        class="
                          metrics-containers
                          d-flex
                          align-items-center
                          justify-content-between
                          pointer
                        "
                        :style="{
                          borderRadius: isOpenDuration ? '8px 8px 0 0' : '',
                        }"
                        @click="isOpenDuration = !isOpenDuration"
                      >
                        <div class="d-flex align-items-center gap-10">
                          <img
                            :src="
                              require('@/assets/img/botanalysis/duration.svg')
                            "
                            alt
                          />
                          <div class="fs-16 fw-700 font-mont color-mainblue">
                            Duration Of Talk
                          </div>
                          <div
                            class="
                              metric-spoken-tag
                              fs-14
                              fw-500
                              color-mainblue
                              font-inter
                            "
                          >
                            {{ candidate.conversationPercentage }}% spoken by
                            Candidate
                          </div>
                        </div>
                        <div class="d-flex align-items-center gap-10">
                          <div
                            class="
                              metric-green-time
                              fs-14
                              font-mont
                              fw-800
                              color-green
                            "
                          >
                            {{ convertMinutes(analysisData.interviewDuration) }}
                          </div>
                          <img
                            :class="{ rotated: isOpenDuration }"
                            :src="
                              require('@/assets/img/botanalysis/downchevoron.svg')
                            "
                            alt
                          />
                        </div>
                      </div>
                      <transition
                        name="collapse"
                        @enter="onEnter"
                        @after-enter="onAfterEnter"
                        @leave="onLeave"
                        @after-leave="onAfterLeave"
                      >
                        <div
                          v-show="isOpenDuration"
                          class="collapsible-body-content"
                        >
                          <hr class="mt-0" />

                          <div
                            class="
                              fs-14
                              font-inter
                              fw-600
                              font-italic
                              color-515151
                            "
                          >
                            Interview duration:
                            <span class="color-mainblue">
                              {{
                                convertMinutes(analysisData.interviewDuration)
                              }}
                            </span>
                          </div>
                          <div class="divider"></div>
                          <div id="InterviewTimeline"></div>
                          <div class="divider"></div>
                          <section class="d-flex align-items-baseline">
                            <div
                              class="
                                fs-14
                                font-inter
                                fw-600
                                font-italic
                                color-515151
                              "
                              style="min-width: 140px"
                            >
                              Participants on call:
                            </div>
                            <div class="d-flex flex-wrap gap-3" style="flex: 1">
                              <div
                                v-for="(item, index) in analysisData.speakers"
                                :key="index"
                                class="
                                  ml-2
                                  firstmetric-tag
                                  d-flex
                                  align-items-center
                                  gap-10
                                "
                              >
                                <div :style="greendotStyle(item.color)"></div>
                                <div
                                  class="
                                    fs-14
                                    fw-400
                                    font-inter
                                    color-darkblack
                                  "
                                >
                                  {{ item.speakerName }}
                                </div>
                                <div
                                  v-if="item.speakerName != candidate.name"
                                  :class="
                                    item.role == 'PANELIST'
                                      ? 'color-panelist panelist-bg'
                                      : 'color-mainblue candidatetag-bg'
                                  "
                                  class="transcripttag fw-500 fs-12 font-mont"
                                >
                                  {{ item.role }}
                                </div>
                                <div
                                  v-else
                                  class="
                                    transcripttag
                                    fw-500
                                    fs-12
                                    font-mont
                                    color-mainblue
                                    candidatetag-bg
                                  "
                                >
                                  Candidate
                                </div>
                                <img
                                  src="@/assets/img/botanalysis/line.svg"
                                  alt
                                />
                                <div
                                  class="fw-700 fs-14 color-mainblue font-inter"
                                >
                                  {{ item.conversationPercentage }}%
                                </div>
                              </div>
                            </div>
                            <!-- <div
                             v-for="(_,ind) in 10"
                             :key="ind"
                              class="
                                ml-3
                                firstmetric-tag
                                d-flex
                                align-items-center
                                gap-10
                              "
                            >
                              <div class="yellowdot"></div>
                              <div
                                class="fs-14 fw-400 font-inter color-darkblack"
                              >
                                {{ candidate.speakerName }}
                              </div>
                              <div
                                class="
                                  transcripttag
                                  fw-500
                                  fs-12
                                  font-mont
                                  color-mainblue
                                  candidatetag-bg
                                "
                              >
                                Candidate
                              </div>
                              <img
                                src="@/assets/img/botanalysis/line.svg"
                                alt
                              />
                              <div
                                class="fw-700 fs-14 color-mainblue font-inter"
                              >
                                {{
                                  Math.round(
                                    candidate
                                      .conversationPercentage
                                  )
                                }}%
                              </div>
                            </div> -->
                          </section>
                        </div>
                      </transition>
                    </section>

                    <!-- 2. Conversation rating & Tonality -->
                    <section>
                      <div
                        class="
                          metrics-containers
                          d-flex
                          align-items-center
                          justify-content-between
                          pointer
                        "
                        :style="{
                          borderRadius: isOpenTonality ? '8px 8px 0 0' : '',
                        }"
                        @click="isOpenTonality = !isOpenTonality"
                      >
                        <div class="d-flex align-items-center gap-10">
                          <img
                            :src="
                              require('@/assets/img/botanalysis/convorating.svg')
                            "
                            alt
                          />
                          <div class="fs-16 fw-700 font-mont color-mainblue">
                            Conversation rating & Tonality
                          </div>
                        </div>
                        <div class="d-flex align-items-center gap-10">
                          <div
                            :class="
                              analysisData.metrics[candidate.name]
                                .emotionalState == 'RUDE'
                                ? 'color-red'
                                : analysisData.metrics[candidate.name]
                                    .emotionalState == 'NEUTRAL'
                                ? 'color-orange'
                                : 'color-green'
                            "
                            :style="
                              analysisData.metrics[candidate.name]
                                .emotionalState == 'RUDE'
                                ? 'background: rgb(251, 235, 234);'
                                : analysisData.metrics[candidate.name]
                                    .emotionalState == 'NEUTRAL'
                                ? 'background: #ffdd8073'
                                : ''
                            "
                            class="metric-green-time fs-14 font-mont fw-800"
                          >
                            {{
                              getEmotionName(
                                analysisData.metrics[candidate.name]
                                  .emotionalState
                              )
                            }}
                          </div>
                          <img
                            :class="{ rotated: isOpenTonality }"
                            :src="
                              require('@/assets/img/botanalysis/downchevoron.svg')
                            "
                            alt
                          />
                        </div>
                      </div>
                      <transition
                        name="collapse"
                        @enter="onEnter"
                        @after-enter="onAfterEnter"
                        @leave="onLeave"
                        @after-leave="onAfterLeave"
                      >
                        <div
                          v-show="isOpenTonality"
                          class="collapsible-body-content"
                        >
                          <hr class="mt-0" />
                          <!-- add your graph here -->

                          <section
                            class="position-relative d-flex align-items-center"
                          >
                            <div class="w-90">
                              <div id="ratingGraph"></div>
                            </div>
                            <div
                              class="vertical-divider"
                              style="left: 90%"
                            ></div>
                            <div class="w-10 pl-3">
                              <section
                                class="d-flex align-items-center gap-5px w-100"
                              >
                                <div
                                  class="conversation-graph-notification"
                                ></div>
                                <div
                                  class="fw-500 font-mont fs-12 color-darkblack"
                                >
                                  Good
                                </div>
                              </section>
                              <section
                                class="d-flex align-items-center gap-5px w-100"
                              >
                                <div
                                  class="
                                    cgn-neutral
                                    conversation-graph-notification
                                  "
                                ></div>
                                <div
                                  class="fw-500 font-mont fs-12 color-darkblack"
                                >
                                  Neutral
                                </div>
                              </section>
                              <section
                                class="d-flex align-items-center gap-5px w-100"
                              >
                                <div
                                  class="
                                    cgn-rude
                                    conversation-graph-notification
                                  "
                                ></div>
                                <div
                                  class="fw-500 font-mont fs-12 color-darkblack"
                                >
                                  Rude
                                </div>
                              </section>
                              <section
                                class="d-flex align-items-center gap-5px w-100"
                              >
                                <img
                                  src="../../assets/img/botanalysis/apnelistgraph.svg"
                                  alt=""
                                />
                                <div
                                  class="fw-500 font-mont fs-12 color-darkblack"
                                >
                                  Panellist
                                </div>
                              </section>
                              <section
                                class="d-flex align-items-center gap-5px w-100"
                              >
                                <img
                                  src="../../assets/img/botanalysis/candidategraph.svg"
                                  alt=""
                                />
                                <div
                                  class="fw-500 font-mont fs-12 color-darkblack"
                                >
                                  Candidate
                                </div>
                              </section>
                            </div>
                          </section>
                          <div class="divider my-1"></div>
                          <p
                            class="
                              fs-14
                              fw-400
                              font-italic font-inter
                              color-515151
                            "
                          >
                            Participation reflects your engagement level during
                            the interview, measured by speaking time and
                            responsiveness.
                          </p>
                        </div>
                      </transition>
                    </section>

                    <!-- 3. Confidence level -->
                    <section>
                      <div
                        class="
                          metrics-containers
                          d-flex
                          align-items-center
                          justify-content-between
                          pointer
                        "
                        :style="{
                          borderRadius: isOpenConfidence ? '8px 8px 0 0' : '',
                        }"
                        @click="isOpenConfidence = !isOpenConfidence"
                      >
                        <div class="d-flex align-items-center gap-10">
                          <img
                            :src="
                              require('@/assets/img/botanalysis/confidence.svg')
                            "
                            alt
                          />
                          <div class="fs-16 fw-700 font-mont color-mainblue">
                            Confidence level
                          </div>
                          <div
                            class="
                              metric-spoken-tag
                              fs-14
                              fw-500
                              color-mainblue
                              font-inter
                            "
                          >
                            {{ Math.round(candidate.confidenceLevel) }}%
                            Confidence shown by candidate
                          </div>
                        </div>
                        <div class="d-flex align-items-center gap-10">
                          <!-- color-orange -->
                          <!-- style="background: #ffdd8073" -->
                          <div
                            :class="
                              candidate.confidenceLevel <
                              analysisData.licenseAvgConfidence
                                ? 'color-red'
                                : candidate.confidenceLevel ==
                                  analysisData.licenseAvgConfidence
                                ? 'color-orange'
                                : 'color-green'
                            "
                            :style="
                              candidate.confidenceLevel <
                              analysisData.licenseAvgConfidence
                                ? 'background: rgb(251, 235, 234);'
                                : candidate.confidenceLevel ==
                                  analysisData.licenseAvgConfidence
                                ? 'background: #ffdd8073'
                                : ''
                            "
                            class="metric-green-time fs-14 font-mont fw-800"
                          >
                            {{ Math.round(candidate.confidenceLevel) }}%
                          </div>
                          <img
                            :class="{ rotated: isOpenConfidence }"
                            :src="
                              require('@/assets/img/botanalysis/downchevoron.svg')
                            "
                            alt
                          />
                        </div>
                      </div>
                      <transition
                        name="collapse"
                        @enter="onEnter"
                        @after-enter="onAfterEnter"
                        @leave="onLeave"
                        @after-leave="onAfterLeave"
                      >
                        <div
                          v-show="isOpenConfidence"
                          class="collapsible-body-content"
                        >
                          <hr class="mt-0" />
                          <div
                            class="d-flex align-items-center position-relative"
                          >
                            <div style="width: 49%">
                              <ul>
                                <li
                                  v-for="(data, index) in analysisData
                                    .pointersResponse.confidencePointers"
                                  :key="index + 'confidence'"
                                  class="
                                    fw-400
                                    fs-14
                                    font-inter font-italic
                                    color-515151
                                    text-left
                                  "
                                >
                                  {{ data }}
                                </li>
                              </ul>
                            </div>
                            <div class="vertical-divider"></div>
                            <div style="width: 49%">
                              <ProgressBar
                                :licenseAvg="analysisData.licenseAvgConfidence"
                                :candScore="
                                  Math.round(candidate.confidenceLevel)
                                "
                              />
                              <!-- import progressbar component here with neccessary conditions -->
                            </div>
                          </div>
                        </div>
                      </transition>
                    </section>

                    <!-- 4. Grammatical Analysis -->
                    <section>
                      <div
                        class="
                          metrics-containers
                          d-flex
                          align-items-center
                          justify-content-between
                          pointer
                        "
                        :style="{
                          borderRadius: isOpenGrammar ? '8px 8px 0 0' : '',
                        }"
                        @click="isOpenGrammar = !isOpenGrammar"
                      >
                        <div class="d-flex align-items-center gap-10">
                          <img
                            :src="
                              require('@/assets/img/botanalysis/grammatical.svg')
                            "
                            alt
                          />
                          <div class="fs-16 fw-700 font-mont color-mainblue">
                            Grammatical Analysis
                          </div>
                        </div>
                        <div class="d-flex align-items-center gap-10">
                          <div
                            :class="
                              candidate.grammarAccuracy <
                              analysisData.licenseAvgGrammarAccuracy
                                ? 'color-red'
                                : candidate.grammarAccuracy ==
                                  analysisData.licenseAvgGrammarAccuracy
                                ? 'color-orange'
                                : 'color-green'
                            "
                            :style="
                              candidate.grammarAccuracy <
                              analysisData.licenseAvgGrammarAccuracy
                                ? 'background: rgb(251, 235, 234);'
                                : candidate.grammarAccuracy ==
                                  analysisData.licenseAvgGrammarAccuracy
                                ? 'background: #ffdd8073'
                                : ''
                            "
                            class="metric-green-time fs-14 font-mont fw-800"
                          >
                            {{ Math.round(candidate.grammarAccuracy) }}%
                            Proficient
                          </div>
                          <img
                            :class="{ rotated: isOpenGrammar }"
                            :src="
                              require('@/assets/img/botanalysis/downchevoron.svg')
                            "
                            alt
                          />
                        </div>
                      </div>
                      <transition
                        name="collapse"
                        @enter="onEnter"
                        @after-enter="onAfterEnter"
                        @leave="onLeave"
                        @after-leave="onAfterLeave"
                      >
                        <div
                          v-show="isOpenGrammar"
                          class="collapsible-body-content"
                        >
                          <hr class="mt-0" />
                          <div
                            class="d-flex align-items-center position-relative"
                          >
                            <div style="width: 49%">
                              <ul>
                                <li
                                  v-for="(data, index) in analysisData
                                    .pointersResponse.grammarPointers"
                                  :key="index + 'grammer'"
                                  class="
                                    fw-400
                                    fs-14
                                    font-inter font-italic
                                    color-515151
                                    text-left
                                  "
                                >
                                  {{ data }}
                                </li>
                              </ul>
                            </div>
                            <div class="vertical-divider"></div>
                            <div style="width: 49%">
                              <ProgressBar
                                :licenseAvg="
                                  analysisData.licenseAvgGrammarAccuracy
                                "
                                :candScore="
                                  Math.round(candidate.grammarAccuracy)
                                "
                              />
                              <!-- import progressbar component here with neccessary conditions -->
                            </div>
                          </div>
                        </div>
                      </transition>
                    </section>
                  </section>
                </b-tab>
                <b-tab
                  v-if="analysisData.aiReport"
                  title="Skills metrics"
                  class="pr-1"
                >
                  <div class="fs-18 fw-700 font-mont color-mainblue">
                    <img
                      src="@/assets/img/botanalysis/intsummary.svg"
                      class="mr-2"
                      alt
                    />
                    AI Report Summary
                  </div>
                  <div class="p-2 d-flex flex-column font-inter gap-10">
                    <div
                      class="d-flex flex-column ai-report-sec"
                      v-for="(skill, index) in analysisData.aiReport.skills"
                      :key="index"
                    >
                      <div>
                        <span class="fw-600 fs-15"
                          >{{ skill.skillName }}:
                        </span>
                        <span class="fs-14">{{ skill.skillRating }}/5 </span>
                      </div>
                      <div>
                        <span class="fw-600 fs-15">Reason: </span>
                        <span class="fs-14"> {{ skill.skillReason }}</span>
                      </div>
                    </div>
                    <div>
                      <span class="fw-600 fs-15">Overall Performance: </span>
                      <span class="fs-14">{{
                        analysisData.aiReport.overallPerformance
                      }}</span>
                    </div>
                    <div class="d-flex align-items-center gap-10">
                      <span class="fw-600 fs-15">Hire: </span>
                      <span
                        class="ai-tag fs-11 fw-400"
                        :class="
                          analysisData.aiReport.hire.toLowerCase() == 'yes'
                            ? 'color-green bg-green'
                            : 'color-darkred bg-darkred'
                        "
                      >
                        {{ analysisData.aiReport.hire }}
                      </span>
                    </div>
                    <div class="d-flex align-items-center gap-10">
                      <span class="fw-600 fs-15">Trainable: </span>
                      <span
                        class="ai-tag fs-11 fw-400"
                        :class="
                          analysisData.aiReport.trainable.toLowerCase() == 'yes'
                            ? 'color-green bg-green'
                            : 'color-darkred bg-darkred'
                        "
                      >
                        {{ analysisData.aiReport.trainable }}
                      </span>
                    </div>
                  </div>
                </b-tab>
                <b-tab
                  v-if="
                    analysisData.aiReport &&
                    analysisData.aiReport.questionReports &&
                    analysisData.aiReport.questionReports.length != 0
                  "
                  title="Q & A Summary"
                  class="pr-1"
                >
                  <div class="question-overlfow">
                    <div
                      v-for="(q, index) in analysisData.aiReport
                        .questionReports"
                      :key="index"
                      class="ques-card"
                      :ref="`question-${index}`"
                    >
                      <div class="d-flex align-items-center gap-2">
                        <img
                          class="img-1"
                          src="../../assets/img/botanalysis/rep-question.svg"
                          alt=""
                        />
                        <span
                          class="
                            font-lato
                            fw-600
                            fs-16
                            text-383838
                            white-space-no-wrap
                          "
                          >Q{{ q.questionNumber }}</span
                        >
                        <div
                          style="
                            height: 20px;
                            width: 1px;
                            background-color: #9eb3c6;
                          "
                        ></div>
                        <span class="font-lato fw-600 fs-18 color-darkblack">
                          {{ q.question }}
                        </span>
                      </div>
                      <div class="dashed-div"></div>
                      <div class="answer-card">
                        <div
                          class="
                            d-flex
                            align-items-center
                            gap-2
                            font-lato
                            fw-600
                            fs-16
                            color-mainblue
                          "
                        >
                          <img
                            class="img-1"
                            src="../../assets/img/botanalysis/rep-answer.svg"
                            alt=""
                          />Candidate Answer Summary
                        </div>
                        <p class="font-lato fw-400 fs-16 color-black mb-0 mt-2">
                          {{ q.answerSummary }}
                        </p>
                      </div>
                      <div class="d-flex align-items-center gap-3 my-3">
                        <div class="line"></div>
                        <div class="font-lato fw-600 fs-16 color-595959">
                          Key Insights
                        </div>
                        <div class="line"></div>
                      </div>
                      <div class="d-flex gap-3 ques-hor-scroll">
                        <div class="strength">
                          <div
                            class="
                              d-flex
                              align-items-center
                              gap-2
                              font-mont
                              fw-700
                              fs-18
                              color-green
                            "
                          >
                            <img
                              class="img-1"
                              src="../../assets/img/botanalysis/rep-strength.svg"
                              alt=""
                            />Strengths
                          </div>
                          <div class="dashed-div-2"></div>
                          <p
                            class="font-lato fw-400 fs-16 color-3a3c40 mb-0"
                            :class="
                              checkValueExists(q.strengths)
                                ? 'd-flex align-items-center justify-content-center'
                                : ''
                            "
                            :style="
                              checkValueExists(q.strengths) ? 'flex: 1' : ''
                            "
                          >
                            {{
                              checkValueExists(q.strengths)
                                ? "N/A"
                                : q.strengths
                            }}
                          </p>
                        </div>
                        <div class="weakness">
                          <div
                            class="
                              d-flex
                              align-items-center
                              gap-2
                              font-mont
                              fw-700
                              fs-18
                              text-blue
                            "
                          >
                            <img
                              class="img-1"
                              src="../../assets/img/botanalysis/rep-weak.svg"
                              alt=""
                            />Weakness
                          </div>
                          <div class="dashed-div-2"></div>
                          <p
                            class="font-lato fw-400 fs-16 color-3a3c40 mb-0"
                            :class="
                              checkValueExists(q.weakness)
                                ? 'd-flex align-items-center justify-content-center'
                                : ''
                            "
                            :style="
                              checkValueExists(q.weakness) ? 'flex: 1' : ''
                            "
                          >
                            {{
                              checkValueExists(q.weakness) ? "N/A" : q.weakness
                            }}
                          </p>
                        </div>
                        <div class="clarification">
                          <div
                            class="
                              d-flex
                              align-items-center
                              gap-2
                              font-mont
                              fw-700
                              fs-18
                              color-fb923c
                            "
                          >
                            <img
                              class="img-1"
                              src="../../assets/img/botanalysis/rep-clar.svg"
                              alt=""
                            />Clarification Needed
                          </div>
                          <div class="dashed-div-2"></div>
                          <p
                            class="font-lato fw-400 fs-16 color-3a3c40 mb-0"
                            :class="
                              checkValueExists(q.clarificationNeeded)
                                ? 'd-flex align-items-center justify-content-center'
                                : ''
                            "
                            :style="
                              checkValueExists(q.clarificationNeeded)
                                ? 'flex: 1'
                                : ''
                            "
                          >
                            {{
                              checkValueExists(q.clarificationNeeded)
                                ? "N/A"
                                : q.clarificationNeeded
                            }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-tab>
              </b-tabs>
            </div>
          </div>
        </section>
        <section
          v-if="analysisData.videoLink || analysisData.interviewImage"
          class="h-100 bot-right-container"
        >
          <!-- <div class="bot-right-video-conatiner w-100"> -->
          <section class="mb-2" v-if="analysisData.interviewImage">
            <span class="viewvideo-font"> Candidate Screenshot </span>
            <img
              :src="analysisData.interviewImage"
              class="w-100"
              style="height: 190px"
              alt="Interview Image"
            />
          </section>

          <template
            v-if="
              analysisData.videoLink ||
              (!analysisData.videoLink && analysisData.isVideoPresent)
            "
          >
            <span class="viewvideo-font"> Video </span>
            <video
              v-if="analysisData.videoLink"
              :src="analysisData.videoLink"
              ref="myVideo"
              id="video"
              class="bot-right-video-conatiner w-100"
              alt
              @seeked="onSeeked"
              @play="onPlay"
              @timeupdate="onTimeUpdate"
              controls
              @contextmenu.prevent
            />
            <div
              v-else-if="analysisData.isVideoPresent"
              style="height: 250px"
              class="cvs-black-screen-processing"
            >
              <div class="white-bar-loader">
                <div v-for="i in 8" :key="i"></div>
              </div>
              <div class="text-white-1">Video Processing...</div>
              <div class="text-white-2">Please come back in some time</div>
            </div>
          </template>
          <!-- <img
              src="@/assets/img/botanalysis/dummyvideo.png"
              class="h-100 w-100 overflow-hidden"
              alt=""
          />-->
          <!-- </div> -->
          <!-- <div class="fs-16 fw-500 font-mont color-656565 mt-3">Key Moments :-</div>
          <hr class="mt-2" />
          <section>
            <section>
              <div class="d-flex align-items-start justify-content-between w-100">
                <div style="width: calc(100% - 125px)">
                  <div class="d-flex align-items-center gap-15">
                    <div class="ba-questiontag fs-14 fw-600 font-mont">
                      <img src="@/assets/img/botanalysis/questionstar.svg" alt class="mr-1" />
                      Question
                    </div>
                    <div style="color: #468ad3" class="fw-700 font-mont fs-14">01:11</div>
                  </div>
                  <p
                    style="color: #434f5e"
                    class="fw-500 fs-14 font-mont mt-2"
                  >Qorem ipsum dolor sit amet, consectetur</p>
                </div>
                <div class="ba-quesans-thumbnail">
                  <img
                    src="@/assets/img/botanalysis/dummykeymoments.png"
                    class="h-100 w-100 overflow-hidden"
                    alt
                  />
                </div>
              </div>
            </section>
            <div class="divider my-2"></div>
            <section>
              <div class="d-flex align-items-start justify-content-between w-100">
                <div style="width: calc(100% - 130px)">
                  <div class="d-flex align-items-center gap-15">
                    <div class="ba-answertag fs-14 fw-600 font-mont color-green">
                      <img src="@/assets/img/botanalysis/answerstar.svg" alt class="mr-1" />
                      Answer
                    </div>
                    <div style="color: #468ad3" class="fw-700 font-mont fs-14">2:31</div>
                  </div>
                  <p style="color: #434f5e" class="fw-500 fs-14 font-mont mt-2">
                    Qorem ipsum dolor sit amet, consectetur adipiscing elit.
                    Qorem ip Qorem ip lsahdlasjfp
                  </p>
                </div>
                <div class="ba-quesans-thumbnail">
                  <img
                    src="@/assets/img/botanalysis/dummykeymoments.png"
                    class="h-100 w-100 overflow-hidden"
                    alt
                  />
                </div>
              </div>
            </section>
          </section> -->
        </section>
      </section>
    </div>
    <PreviewFeedback
      v-if="showFeedback"
      :selectedRound="feedbackData.feedBackForm.customFeedback"
      :allData="feedbackData"
      :basicCandInfo="feedbackData.customFeedback.basicInfo"
      :ipmodal="showFeedback"
      :showScreenshot="true"
      @closeModal="showFeedback = false"
    />
  </div>
</template>

<script>
import { getBotAnalysis, getFeedbackHistory } from "@/utils/apiFunctions.js";
import Spinner from "@/components/fixedcomponents/Spinner.vue";
import ProgressBar from "@/components/fixedcomponents/ProgressBar.vue";
import PreviewFeedback from "@/views/InterviewProcess/PreviewFeedback.vue";
import { AnalysisGraph } from "./analysisGraph";
import toast from "../../components/mixin/toast";
import { mapGetters } from "vuex";
import { converterAtsPreview } from "../../utils/apiFunctions";

export default {
  name: "BotAnalysis",
  data() {
    return {
      tabIndex: 0,
      datatags: 20,
      LoaderStatus: false,
      sharedModal: false,
      isOpenDuration: false,
      isOpenTonality: false,
      isOpenConfidence: false,
      isOpenGrammar: false,
      linkCopied: false,
      showFeedback: false,
      userPausedScroll: false,
      transcriptSel: false,
      isDownloading: false,
      scrollCheckInterval: null,
      formattedSummary: null,
      videoPause: false,
      candidate: null,
      feedbackData: {},
      selectedTranscript: { keyword: null, speaker: null, transcripts: [] },
      analysisData: { speakers: [], metrics: {}, candidateInfo: {} },
    };
  },
  mixins: [toast],
  components: { Spinner, ProgressBar, PreviewFeedback },
  created() {
    this.getBotAnalysisData();
    setTimeout(() => {
      this.getInterviewTimeline();
      this.getRatingGraph();
    }, 1000);
  },
  watch: {
    tabIndex() {
      this.scrollTop();
    },
  },
  computed: {
    getLink() {
      let link = `https://recruitment.hire3x.com/jdflow/botanalysis/?intid=${this.$route.query.intid}&type=${this.$route.query.type}`;
      if (this.$route.query.intparams)
        link = link + `&intparams=${this.$route.query.intparams}`;
      return link;
    },
    reversedSpeakers() {
      return [...this.analysisData.speakers].reverse();
    },
    ...mapGetters(["roles"]),
  },
  methods: {
    async downloadReport(html) {
      try {
        const blob = new Blob([html], {
          type: "text/html",
        });
        const formData = new FormData();
        formData.append("htmlFile", blob);
        formData.append("returnType", "pdf");
        formData.append(
          "outputPath",
          `${this.analysisData.candidateInfo.name}`
        );
        formData.append("type", "dossier");
        const res = await converterAtsPreview(formData);
        if (res.status == 200) {
          const blob = new Blob([res.data], { type: "application/pdf" });

          const url = window.URL.createObjectURL(blob);

          const a = document.createElement("a");
          a.href = url;
          a.download = `${this.analysisData.candidateInfo.name}.pdf`;
          document.body.appendChild(a);
          a.click();
        } else {
          this.errorModal("Something went wrong!");
        }
      } catch (error) {
        console.error(error);
        this.errorModal("Something went wrong!");
      } finally {
        this.isDownloading = false;
      }
    },
    getDownloadData() {
      this.isDownloading = true;
      this.getBotAnalysisData("download");
    },
    checkValueExists(type) {
      return !type || type.toLowerCase() == "none";
    },
    getRoundedPercentages(values) {
      const total = values.reduce((a, b) => a + b, 0);
      const raw = values.map((v) => (v / total) * 100);
      const floored = raw.map(Math.floor);
      const remainder = 100 - floored.reduce((a, b) => a + b, 0);
      const fractions = raw.map((val, idx) => ({
        index: idx,
        fraction: val - Math.floor(val),
      }));
      fractions.sort((a, b) => b.fraction - a.fraction);
      for (let i = 0; i < remainder; i++) {
        floored[fractions[i].index]++;
      }
      return floored;
    },
    vidplay(value) {
      this.clearHighlights();
      this.transcriptSel = true;
      this.$nextTick(() => {
        this.analysisData.transcript.map((obj) => {
          if (obj.start == value) {
            obj.highlight = true;
          }
          return obj;
        });
        const videos = document.querySelectorAll("video");
        const totalSeconds = parseFloat(value);
        for (const video of videos) {
          video.currentTime = totalSeconds;
          video.play();
        }
      });
    },
    roundEachDecimal(num) {
      if (num > 1) return Math.round(num);
      else {
        return parseFloat(num.toFixed(1));
      }
    },
    findSpeaker(speaker) {
      this.selectedTranscript.keyword = null;
      this.selectedTranscript.speaker = speaker;
      this.clearHighlights();
      this.analysisData.transcript.map((obj) => {
        if (obj.speaker == speaker) {
          obj.highlight = true;
        }
        return obj;
      });
      this.scrollToHighlight();
    },
    onSeeked() {
      this.selectedTranscript.keyword = null;
      this.selectedTranscript.speaker = null;
      if (!this.transcriptSel) this.clearHighlights();
      this.userPausedScroll = false;
      this.transcriptSel = false;
    },
    onPlay() {
      if (this.videoPause) {
        this.userPausedScroll = false;
        this.clearHighlights();
      }
      this.videoPause = false;
      this.selectedTranscript = {
        keyword: null,
        speaker: null,
        transcripts: [],
      };
    },
    clearHighlights() {
      this.analysisData.transcript = this.analysisData.transcript.map(
        (obj) => ({
          ...obj,
          highlight: false,
        })
      );
    },
    findKeyword(word) {
      this.selectedTranscript.keyword = word;
      this.selectedTranscript.speaker = null;
      this.analysisData.transcript.map((obj) => {
        if (obj.text.toLowerCase().includes(word.toLowerCase())) {
          obj.highlight = true;
          this.$forceUpdate();
        }
        return obj;
      });
      this.analysisData.transcript = [...this.analysisData.transcript];
      this.scrollToHighlight();
    },
    scrollToHighlight() {
      this.$nextTick(() => {
        const el = this.$refs.highlightedSection?.[0];
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      });
    },
    pauseVideo(type, data) {
      const video = document.getElementById("video");
      video.pause();
      this.videoPause = true;
      this.clearHighlights();
      this.$nextTick(() => {
        if (type == "word") this.findKeyword(data);
        else this.findSpeaker(data);
      });
    },
    greendotStyle(color) {
      return {
        width: "12px",
        height: "12px",
        backgroundColor: color,
        borderRadius: "100px",
      };
    },
    getRatingGraph() {
      const element = document.querySelector("#ratingGraph");
      if (!element) {
        console.error("The element #RatingGraph does not exist.");
        return;
      }
      // const datas = this.analysisData.;
      const data = this.analysisData.converstionRatingGraph;
      const rawData = {};

      Object.entries(data).forEach(([speaker, stats]) => {
        rawData[speaker] = {
          role: stats.role.charAt(0) + stats.role.slice(1).toLowerCase(),
          Good: stats.good,
          Neutral: stats.neutral,
          Rude: stats.rude,
        };
      });

      const graph = new AnalysisGraph();
      graph.communicationRatingGraph("#ratingGraph", rawData);
    },
    getInterviewTimeline() {
      const element = document.querySelector("#InterviewTimeline");
      if (!element) {
        console.error("The element #InterviewTimeline does not exist.");
        return;
      }
      const datas = JSON.parse(JSON.stringify(this.analysisData.transcript));
      const availableColors = [
        "#269C8A",
        "#F5D06E",
        "#AD1927",
        "#6A4C93",
        "#1985A1",
        "#FF8552",
        "#4ECDC4",
        "#FF6B6B",
        "#C792EA",
        "#D9BF77",
      ];

      const uniqueSpeakers = Array.from(
        new Set(datas.map((d) => d.speaker).filter((s) => s !== "NEUTRAL"))
      );

      const speakerColors = { NEUTRAL: "#CCCCCC" };
      uniqueSpeakers.forEach((speaker, index) => {
        speakerColors[speaker] =
          availableColors[index % availableColors.length];
      });

      this.analysisData.speakers = this.analysisData.speakers.map((s) => ({
        ...s,
        color: speakerColors[s.speakerName] || "#000000",
      }));

      const sortedData = datas.sort((a, b) => a.start - b.start);

      const filledData = [];

      if (sortedData.length > 0 && sortedData[0].start > 0) {
        filledData.push({
          speaker: "NEUTRAL",
          start: 0,
          end: sortedData[0].start,
          text: "",
          highlight: false,
          color: speakerColors["NEUTRAL"],
        });
      }

      for (let i = 0; i < sortedData.length; i++) {
        const current = sortedData[i];
        current.color = speakerColors[current.speaker] || "#000000";
        filledData.push(current);

        const next = sortedData[i + 1];
        if (next && current.end < next.start) {
          filledData.push({
            speaker: "NEUTRAL",
            start: current.end,
            end: next.start,
            text: "",
            highlight: false,
            color: speakerColors["NEUTRAL"],
          });
        }
      }

      const data = filledData;
      const timelineChart = new AnalysisGraph();
      timelineChart.horizontalTimelineGraph("#InterviewTimeline", data);
    },
    goToKanban() {
      let queryVal = { feedbackModal: true, ...this.$route.query };
      delete queryVal.intid;
      delete queryVal.type;
      delete queryVal.fromkanban;
      delete queryVal.intparams;
      if (
        this.$route.query.givefeed ||
        this.$route.query.history ||
        this.$route.query.preview
      )
        delete queryVal.feedbackModal;
      else {
        delete queryVal.givefeed;
        delete queryVal.history;
      }
      if (this.$route.query.history || this.$route.query.preview) {
        delete queryVal.round;
        delete queryVal.candidateID;
        delete queryVal.frompool;
      }
      const routeName = this.$route.query.fromPage;
      delete queryVal.fromPage;
      this.$router.push({
        name: routeName,
        query: queryVal,
      });
    },
    goToProfilePage() {
      let queryVal = { from: "BotAnalysis" };
      queryVal = { ...this.$route.query, ...queryVal };
      this.$router.push({
        name: "ViewCandidateProfile",
        params: {
          email: this.analysisData.candidateInfo.email,
        },
        query: queryVal,
      });
    },
    setTranscript() {
      this.$nextTick(() => {
        const container = this.$refs.transcriptContainer;
        if (container) {
          container.addEventListener("scroll", () => {
            this.userPausedScroll = true;

            clearTimeout(this.scrollCheckInterval);
            this.scrollCheckInterval = setTimeout(() => {
              const el = this.$refs.highlightedSection?.[0];
              if (el && this.isElementInView(el)) {
                this.userPausedScroll = false;
              }
            }, 1500);
          });
        }
      });
    },
    onIntersectionChange(entries) {
      entries.forEach((entry) => {
        const index = Number(entry.target.dataset.index);

        if (entry.isIntersecting && index === this.currentHighlightIndex) {
          // User scrolled to the highlighted item manually
          this.manualScrollPause = false;
        }
      });
    },
    onUserScroll() {
      this.isUserScrolling = true;
      this.manualScrollPause = true;

      clearTimeout(this.scrollTimeout);
      this.scrollTimeout = setTimeout(() => {
        this.isUserScrolling = false;
      }, 2000);
    },
    async getFeedBack() {
      try {
        const res = await getFeedbackHistory({
          candidateID: this.analysisData.candidateInfo.candidateID,
          jobID: this.analysisData.jobInfo.jobID,
          interviewID: this.analysisData.interviewID || this.$route.query.intid,
        });
        if (res.status == 200) {
          this.feedbackData = res.data.data[0];
          this.showFeedback = true;
        } else {
          this.errorModal("Something went wrong");
        }
      } catch (error) {
        this.errorModal("Something went wrong");
        console.error(error);
      }
    },
    checkKeyword(word) {
      if (this.videoPause) return this.selectedTranscript.keyword == word;
      else {
        let data = this.analysisData.transcript.find(
          (obj) => obj.highlight == true
        );
        if (data && Object.keys(data).length != 0) {
          let text = data.text.toLowerCase();
          return text.includes(word);
        }
        return false;
      }
    },
    checkHighlight(speakerName) {
      let data = this.analysisData.transcript.find(
        (obj) => obj.speaker == speakerName && obj.highlight == true
      );
      return data?.highlight;
    },
    getEmotionName(emotion) {
      if (emotion) return this.capitalizeFirstLetter(emotion.toLowerCase());
      return null;
    },
    onTimeUpdate() {
      const currentTime = this.$refs.myVideo.currentTime;
      if (!this.videoPause) {
        this.analysisData.transcript = this.analysisData.transcript.map(
          (item) => {
            const isHighlight =
              currentTime >= item.start && currentTime <= item.end;
            return { ...item, highlight: isHighlight };
          }
        );
      }
      this.$nextTick(() => {
        const el = this.$refs.highlightedSection?.[0];
        if (el && !this.userPausedScroll && !this.isElementInView(el)) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      });
    },
    isElementInView(el) {
      const container = this.$refs.transcriptContainer;
      const elRect = el.getBoundingClientRect();
      const containerRect = container.getBoundingClientRect();

      return (
        elRect.top >= containerRect.top && elRect.bottom <= containerRect.bottom
      );
    },
    capitalizeFirstLetter(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
    formatSecondsToMinSec(seconds) {
      const totalSeconds = Math.floor(seconds);
      const hrs = Math.floor(totalSeconds / 3600);
      const mins = Math.floor((totalSeconds % 3600) / 60);
      const secs = totalSeconds % 60;

      const paddedMins = hrs > 0 ? mins.toString().padStart(2, "0") : mins;
      const paddedSecs = secs.toString().padStart(2, "0");

      return hrs > 0
        ? `${hrs}:${paddedMins}:${paddedSecs}`
        : `${mins}:${paddedSecs}`;
    },
    convertMinutes(seconds) {
      const hrs = Math.floor(seconds / 3600);
      const mins = Math.floor((seconds % 3600) / 60);
      const secs = Math.floor(seconds % 60);

      let result = [];
      if (hrs > 0) {
        result.push(`${hrs} hr${hrs > 1 ? "s" : ""}`);
      }
      if (mins > 0) {
        result.push(`${mins} min${mins > 1 ? "s" : ""}`);
      }
      if (secs > 0 || result.length === 0) {
        result.push(`${secs} sec${secs > 1 ? "s" : ""}`);
      }
      return result.join(" ");
    },
    copyTheLink() {
      const textToCopy = this.getLink;
      navigator.clipboard
        .writeText(textToCopy)
        .then(() => {
          this.linkCopied = true;
          setTimeout(() => {
            this.linkCopied = false;
          }, 6000);
        })
        .catch((err) => {
          console.error("Error in copying text: ", err);
        });
    },
    closeShareModal() {
      this.sharedModal = false;
    },
    scrollTop() {
      let elements = document.getElementsByClassName("tab-content");
      if (elements.length > 0) {
        elements[0].scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }
      let qaElements = document.getElementsByClassName("question-overlfow");
      if (qaElements.length > 0) {
        qaElements[0].scrollTop = 0;
      }
    },
    async getBotAnalysisData(download) {
      if (!download) this.LoaderStatus = true;
      try {
        let intParams = this.$route.query.intparams
          ? this.$route.query.intparams + "&analyzeType=1"
          : `?interviewID=${this.$route.query.intid}&analyzeType=${this.$route.query.type}`;
        // let payload = {
        //   interviewID: this.$route.query.intid,
        //   analyzeType: this.$route.query.type,
        // };
        if (download) intParams = intParams + "&download=true";
        const res = await getBotAnalysis(intParams);
        if (res.status == 200) {
          if (!download) {
            this.analysisData = res.data.data;
            if (this.analysisData.transcript) {
              this.analysisData.transcript.map(
                (obj) => (obj.highlight = false)
              );
              if (typeof window.marked !== "undefined") {
                this.formattedSummary = window.marked.parse(
                  this.analysisData.interviewSummary
                );
              }
            }
            if (this.analysisData.speakerRoleMap) {
              Object.keys(this.analysisData.speakerRoleMap).forEach((key) => {
                if (this.analysisData.speakerRoleMap[key] == "CANDIDATE") {
                  this.candidate = this.analysisData.metrics[key];
                  this.candidate.name = key;
                  let datas = this.analysisData.speakers.map((obj) => {
                    return obj.conversationPercentage;
                  });
                  const roundedPercents = this.getRoundedPercentages(datas);
                  this.analysisData.speakers = this.analysisData.speakers.map(
                    (obj, index) => {
                      obj.conversationPercentage = roundedPercents[index];
                      return obj;
                    }
                  );
                  let candData = this.analysisData.speakers.find(
                    (obj) => obj.speakerName == key
                  );
                  if (candData) {
                    const { confidenceLevel, conversationPercentage } =
                      candData;
                    Object.assign(this.candidate, {
                      confidenceLevel,
                      conversationPercentage,
                    });
                  }
                }
              });
            }
            // this.getFeedBack();
            this.LoaderStatus = false;
          } else {
            await this.downloadReport(res.data);
          }
        } else if (res.status == 403) this.$router.push({ path: "/404" });
        else if (download) this.errorModal("Something went wrong!");
      } catch (error) {
        console.error(error);
        if (download) this.errorModal("Something went wrong!");
        this.isDownloading = false;
      }
    },
    onEnter(el) {
      el.style.height = "0";
      el.style.opacity = "0";
      el.style.overflow = "hidden";
      requestAnimationFrame(() => {
        el.style.transition = "height 0.3s ease, opacity 0.3s ease";
        el.style.height = el.scrollHeight + "px";
        el.style.opacity = "1";
      });
    },
    onAfterEnter(el) {
      el.style.height = "auto";
      el.style.overflow = "";
    },
    onLeave(el) {
      el.style.height = el.scrollHeight + "px";
      el.style.opacity = "1";
      el.style.overflow = "hidden";
      requestAnimationFrame(() => {
        el.style.transition = "height 0.3s ease, opacity 0.3s ease";
        el.style.height = "0";
        el.style.opacity = "0";
      });
    },
    onAfterLeave(el) {
      el.style.height = "";
      el.style.opacity = "";
      el.style.overflow = "";
    },
  },
};
</script>

<style>
.botanalysistab .tab-content {
  height: calc(100vh - 210px);
  padding: 16px;
  background: #f1f7ff;
  border-width: 0px 1px 1px 1px;
  border-style: solid;
  border-color: rgba(31, 95, 163, 0.1);
  border-radius: 0px 0px 8px 8px;
  overflow: auto;
}

.hide-scroll-container .tab-content {
  overflow: hidden !important;
}

.botanalysis-tags {
  padding: 4px 8px;
  background: #ffffff;
  border: 1px solid rgba(140, 140, 140, 0.25);
  border-radius: 20px;
}
.botanalysis-subtags {
  padding: 0px 4px;
  background: #f0f0f0;
  backdrop-filter: blur(1.91214px);
  border-radius: 20px;
}
.tagdp {
  width: 20px;
  height: 20px;
  /* border-radius: 12.0001px; */
}
.tagssection-border {
  border-bottom: 1px solid rgba(31, 95, 163, 0.1);
  border-radius: 8px;
}
.ba-transcript-conatiner {
  background: #ffffff;
  border: 1px solid rgba(31, 95, 163, 0.1);
  border-radius: 4px;
  overflow: auto;
  height: calc(100vh - 402px);
  padding: 12px 15px;
}
.transcripttag {
  padding: 2px 8px;
  backdrop-filter: blur(1.91214px);
  border-radius: 20px;
}
.transcript-time-tag {
  padding: 2px 4px;
  background: rgba(206, 206, 206, 0.3);
  backdrop-filter: blur(1.91214px);
  border-radius: 4px;
}
.transcript-dp {
  width: 32px;
  height: 32px;
  border-radius: 19.2001px;
}
.panelist-bg {
  background: linear-gradient(
      0deg,
      rgba(255, 224, 116, 0.15),
      rgba(255, 224, 116, 0.15)
    ),
    #ffffff;
}
.candidatetag-bg {
  background: linear-gradient(
      0deg,
      rgba(32, 99, 155, 0.07),
      rgba(32, 99, 155, 0.07)
    ),
    #ffffff;
}
.color-panelist {
  color: #ef9727;
}
.metrics-containers {
  padding: 12px;
  background: #ffffff;
  box-shadow: 0px 2px 24px rgba(98, 114, 144, 0.1);
  border-radius: 8px;
  height: 56px;
}
.metric-spoken-tag {
  padding: 4px 8px;
  background: #edf4ff;
  border-radius: 4px;
}
.metric-green-time {
  padding: 4px 24px;
  background: rgba(3, 142, 0, 0.1);
  border-radius: 20px;
}
.collapsible-body-content {
  padding: 10px;
  background: #ffffff;
  transition: height 0.3s ease, opacity 0.3s ease;
}

.rotated {
  transform: rotate(180deg);
  transition: transform 0.3s ease;
}
.firstmetric-tag {
  padding: 8px;
  background: #ffffff;
  box-shadow: 0px 1px 4px 2px rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  width: fit-content;
}
.greendot {
  width: 12px;
  height: 12px;
  background: #269c89;
  border-radius: 100px;
}
.yellowdot {
  width: 12px;
  height: 12px;
  background: #f5d06e;
  border-radius: 100px;
}

.vertical-divider {
  border: 1px dashed rgba(140, 140, 140, 0.3);
  transform: rotate(0deg);
  position: absolute;
  height: 100%;
  left: 50%;
  top: 0;
}
.bot-right-container {
  background: #ffffff;
  border: 1px solid rgba(31, 95, 163, 0.1);
  border-radius: 8px;
  width: 30%;
  padding: 15px;
  overflow: auto;
}
.bot-right-video-conatiner {
  height: 190px;
  border-radius: 4.03306px;
  overflow: hidden;
}
.ba-questiontag {
  padding: 3px 8px;
  background: linear-gradient(0deg, #fff6d7, #fff6d7), #ffffff;
  backdrop-filter: blur(1.91214px);
  border-radius: 4px;
  color: #ef9727;
}
.ba-answertag {
  padding: 3px 8px;
  background: linear-gradient(0deg, #e6f4e6, #e6f4e6), #ffffff;
  backdrop-filter: blur(1.91214px);
  border-radius: 4px;
}
.ba-quesans-thumbnail {
  height: 61px;
  border-radius: 4px;
  width: 125px;
  overflow: hidden;
}

.markdown-output {
  font-family: "Inter";
  color: #515151;
}

.markdown-output p {
  margin: 0 0 8px;
  line-height: 1.4;
}

.markdown-output strong {
  color: black !important;
}

.markdown-output li {
  margin-bottom: 4px;
  text-align: left;
}

#ratingGraph {
  overflow-y: scroll;
}
/* .markdown-output strong {
  font-weight: bold;
}

.markdown-output br {
  line-height: 1.5;
} */
.conversation-graph-notification {
  width: 8px;
  height: 8px;
  background: linear-gradient(0deg, #269c8a, #269c8a), #00ae1c;
  border-radius: 50px;
}
.cgn-rude {
  background: linear-gradient(0deg, #ba3e4a, #ba3e4a), #00ae1c;
}
.cgn-neutral {
  background: linear-gradient(0deg, #ffc107, #ffc107), #00ae1c;
}
.ai-report-sec {
  border-bottom: 1px solid rgb(134 152 167);
  padding-bottom: 10px;
}
.ai-tag {
  padding: 4px 8px;
  border-radius: 4px;
}
.question-overlfow {
  width: 100%;
  margin-top: 15px;
  overflow: auto;
  padding-inline: 15px;
  height: calc(100vh - 255px);
  transition: height 0.3s ease;
}
.question-overlfow .ques-card {
  background-color: #fff;
  border-radius: 16px;
  padding: 16px;
  margin-bottom: 15px;
}
.question-overlfow .dashed-div {
  border-bottom: 1px dashed #c5c5c5;
  height: 20px;
  margin-bottom: 20px;
}
.question-overlfow .dashed-div-2 {
  border-bottom: 2px dashed #72738e3b;
  height: 15px;
  margin-bottom: 10px;
}
.question-overlfow .answer-card {
  background-color: #f7f9fc;
  border-radius: 8px;
  padding: 16px;
}
.question-overlfow .line {
  flex: 1;
  height: 1px;
  background-color: #8c8c8c54;
}
.question-overlfow .strength {
  background-color: #f0fdf4;
  padding: 16px;
  border-radius: 8px;
  flex: 1;
  display: flex;
  flex-direction: column;
}
.question-overlfow .weakness {
  background-color: #f3f6ff;
  padding: 16px;
  border-radius: 8px;
  flex: 1;
  display: flex;
  flex-direction: column;
}

.question-overlfow .clarification {
  background-color: #fff6ed;
  padding: 16px;
  border-radius: 8px;
  flex: 1;
  display: flex;
  flex-direction: column;
}
</style>
